'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _class, _temp;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _wavfichacertaFichacertaModals = require('@bit/wavfichacerta.fichacerta.modals.block-navigation-modal');
var _wavfichacertaFichacertaModals2 = _interopRequireDefault(_wavfichacertaFichacertaModals);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var BlockNavigationContainer = (_temp = _class = function (_PureComponent) {
  _inherits(BlockNavigationContainer, _PureComponent);
  function BlockNavigationContainer(props) {
    _classCallCheck(this, BlockNavigationContainer);
    var _this = _possibleConstructorReturn(this, (BlockNavigationContainer.__proto__ || Object.getPrototypeOf(BlockNavigationContainer)).call(this, props));
    _this.navigate = function () {
      var history = _this.props.history;
      history.push({
        pathname: _this.state.path,
        state: _this.state.locationState
      });
      _this.props.onNavigateBack();
    };
    _this.freeNavigate = function (action) {
      _this.setState({
        showModal: false
      }, function () {
        if (!action) {
          _this.unBlock();
          _this.navigate();
        }
      });
    };
    _this.handleNavigation = function () {};
    _this.state = {
      showModal: false,
      path: '',
      locationState: {}
    };
    _this.unBlock = null;
    return _this;
  }
  _createClass(BlockNavigationContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;
      var history = this.props.history;
      this.unBlock = history.block(function (location) {
        if (!_this2.props.blockNavigation()) {
          _this2.setState({
            showModal: true,
            path: location.pathname,
            locationState: location.state
          });
        }
        return _this2.props.blockNavigation();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unBlock();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_react.Fragment, null, this.props.children, this.state.showModal && _react2.default.createElement(_wavfichacertaFichacertaModals2.default, {
        message: this.props.modalMessage,
        callBack: this.freeNavigate
      }));
    }
  }]);
  return BlockNavigationContainer;
}(_react.PureComponent), _class.defaultProps = {
  onNavigateBack: function onNavigateBack() {},
  blockNavigation: function blockNavigation() {
    return false;
  }
}, _temp);
exports.default = BlockNavigationContainer;